/** My Bets header — session logs icon (TexturePacker atlas under public/games/skyx_new). */
export const SKYX_NEW_BET_HISTORY_LOGS_BUTTON = {
  atlasJson: 'images/menu/newpanel0.json',
  /** Atlas frame names (`historyBtn_*` in newpanel0.json). */
  frames: {
    normal: 'historyBtn_normal',
    hover: 'historyBtn_hover',
    down: 'historyBtn_down',
    disabled: 'historyBtn_disable',
  },
  /** Rendered icon width (px); height scales from the atlas frame aspect ratio. */
  iconSizePx: 18,
  /** Gap between the logs icon and the close (×) control (px). */
  gapBeforeClosePx: 8,
} as const;
